import React, { useEffect, useRef, useState } from 'react'
import styles from '../styles/Layout.module.scss';
import { Navigate, Outlet } from 'react-router-dom';
import Topbar from './Topbar';
import Navbar from './Navbar';
import secureLocalStorage from 'react-secure-storage';
import FloatingBubble from '../pages/FloatingBubble/FloatingBubble';
import { connectChatWebSocket } from '../redux/chatWsMiddleware';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { platfromIdFromUserId } from '../commons/platformUtil';
import { fetchNewMessages, setUnReadCount } from '../redux/slices/chatSlice';


export default function Layout({ theme, toggleTheme, account, setAccount, balance, setBalance, margin, setMargin, eurToUsd, usdToEur, setSnackMessage, setSnackType, handleClick, applications,getSymbolByAccount,totalBalanceDemo, AccountTypeEnum, openOrdersCount }) {
  const messages = useSelector(state=> state.chat.messages)
  const [loading, setLoading] = useState(false);
  const [hasMore , setHasMore] = useState(true);
  const dispatch = useDispatch()
  const platform_id = platfromIdFromUserId(secureLocalStorage.getItem('user')?.Id)

  const LoadMoreMessages = async () => {
    if(hasMore && !loading){
      setLoading(true)
        const currentCount   = messages.length;
        const itemsPerPage   = 20;
        const pageToFetch = Math.floor(currentCount / itemsPerPage);

        try {
            const {hasNext} = await dispatch(fetchNewMessages({ page: pageToFetch, platform_id })).unwrap();
            setHasMore(hasNext);
            setLoading(false)
        } catch (error) {
            console.error('Ошибка при загрузке уведомлений:', error);
            setHasMore(false);
        }finally{
          setLoading(false)
        }
    }
  };
  const fetchMessages = async () => {
    try {
      const {data} = await axios.post(`${process.env.REACT_APP_CHAT_SERVICE_HTTP}/init/cabinet/unread`, {platform_id},{
        headers:{
          Authorization:`Bearer ${secureLocalStorage.getItem('token')}`
        }
      })
      if(data > 0 && messages.length === 0){
        setLoading(true);
        dispatch(setUnReadCount(data))
        LoadMoreMessages()
      }
    } catch (error) {
        console.error( error);
        setLoading(false);
    }
  }

  useEffect(() => {
    const AuthChat = async()=>{
      try{
        const {data} = await axios.get(`${process.env.REACT_APP_CHAT_SERVICE_HTTP}/auth/cabinet`,{headers: {Authorization:`Bearer ${secureLocalStorage.getItem('token')}`}})
        if(data){
          secureLocalStorage.setItem('key',data.key)
          secureLocalStorage.setItem('iv',data.iv)
          fetchMessages()
        }
      }catch(e){
        console.log(e)
      }
    }
    AuthChat()  
    dispatch(connectChatWebSocket({ platform_id }))
  }, []);

  if (!secureLocalStorage.getItem('user')) {
    return <Navigate to={'/login'} />
  } else
    return (
      <div className={styles.layout}>
        <Topbar toggleTheme={toggleTheme} theme={theme}
          totalBalanceDemo={totalBalanceDemo}
          getSymbolByAccount={getSymbolByAccount}
          eurToUsd={eurToUsd}
          AccountTypeEnum = {AccountTypeEnum}
          usdToEur={usdToEur}
          account={account}
          applications={applications}
          setAccount={setAccount}
          balance={balance}
          setBalance={setBalance}
          margin={margin}
          setMargin={setMargin}
          setSnackMessage={setSnackMessage}
          setSnackType={setSnackType}
          handleClick={handleClick}
          openOrdersCount={openOrdersCount}
        />
        <div className={styles.page}>
          <Navbar account={account}
            setSnackMessage={setSnackMessage}
            setSnackType={setSnackType}
            handleClick={handleClick}
            openOrdersCount={openOrdersCount}
          />
          <Outlet />
        </div>
        <FloatingBubble platform_id={platform_id} loading={loading} setLoading={setLoading} hasMore={hasMore} setHasMore={setHasMore}/>
      </div>
    )
}
